import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { WorkCollage } from "../work/WorkCollage";
import { workApproach } from "../../data/portfolio";
import { cardHeading } from "../../utils/typography";
import type { WorkItem } from "../../types/work";
type WorkSectionProps = {
  onOpen: (item: WorkItem) => void;
};
export function WorkSection({
  onOpen
}: WorkSectionProps) {
  return <section id="work" aria-labelledby="work-heading" className="relative" data-id="element-302" data-mp="2qy0uoh8xo5zs">
      <WorkCollage onOpen={onOpen} data-id="element-303" data-mp="2qvxvb6lw50ie" />

      <div className="px-5 py-20 md:px-8 md:py-28" data-id="element-304" data-mp="2lyo71ua8muw5">
        <div className="mx-auto max-w-[1480px]" data-id="element-305" data-mp="2lz7hkpxk6h05">
          {/* One consolidated discipline statement rather than two competing columns. */}
          <motion.article initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: "-10%"
        }} transition={{
          duration: 0.6
        }} className="group relative overflow-hidden rounded-[20px] border border-white/10 bg-[#0a0f0e] p-7 sm:p-9 md:p-12" data-id="element-306" data-mp="2cxztt1so4ykb">
            <span aria-hidden="true" className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#54f6c6]/60 to-transparent" data-id="element-307" data-mp="2237ecpqys3pj" />

            <h3 className={`max-w-3xl ${cardHeading}`} data-id="element-308" data-mp="1t92nw7fqsuaj">
              {workApproach.heading.start} <span className="text-[#54f6c6]" data-id="element-309" data-mp="2gywzyms8metq">{workApproach.heading.accent}</span>
            </h3>

            <ul className="mt-8 grid max-w-4xl gap-6 md:mt-10" data-id="element-310" data-mp="2l0i7rtpx02x2">
              {workApproach.points.map(point => <li key={point.description} className="flex gap-4 sm:gap-5" data-id="element-311" data-mp="2718vh54txsyd">
                  <span aria-hidden="true" className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#54f6c6]" data-id="element-312" data-mp="2bzttcxwm00jn" />
                  <p className="text-[15px] leading-7 text-white/85 md:text-base md:leading-8" data-id="element-313" data-mp="vltwxwwz2t15">
                    {point.title && <span className="font-medium text-white" data-id="element-314" data-mp="10kx4bo0fdbca">{point.title}. </span>}
                    <span className="text-white/70" data-id="element-315" data-mp="gianqgcvku57">{point.description}</span>
                  </p>
                </li>)}
            </ul>

            <div className="mt-10 border-t border-white/10 pt-7 md:mt-12" data-id="element-316" data-mp="chgxvhfvh59o">
              <Link to="/videos" data-cursor="View" className="group/cta inline-flex min-h-12 items-center gap-8 border-b border-[#54f6c6] pb-3 text-sm uppercase tracking-[0.08em] text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#54f6c6] sm:gap-10" data-id="element-317" data-mp="7p741qbmzl24">
                View all work
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover/cta:translate-x-1.5" data-id="element-318" data-mp="3kw8tl03dyfvt" />
              </Link>
            </div>
          </motion.article>
        </div>
      </div>
    </section>;
}